module.exports = __webpack_public_path__ + "static/media/pyyle-screenshot-1.a8ef03ed.png";